export const NT8_OVERLAY_WEEKDAYS = [
  { key: 'monday', short: 'Mon' },
  { key: 'tuesday', short: 'Tue' },
  { key: 'wednesday', short: 'Wed' },
  { key: 'thursday', short: 'Thu' },
  { key: 'friday', short: 'Fri' },
];

export const NT8_OVERLAY_DAY_KEYS = NT8_OVERLAY_WEEKDAYS.map((d) => d.key);

export const MAX_NT8_OVERLAY_SLEEVES = 12;

export function makeEmptyNt8OverlaySleeve(defaultDays = NT8_OVERLAY_DAY_KEYS) {
  return {
    strategyName: '',
    days: [...defaultDays],
    size: 1,
  };
}

export function nt8OverlaySleevesFromConfig(config) {
  const cfg = config && typeof config === 'object' ? config : {};
  if (Array.isArray(cfg.nt8OverlaySleeves) && cfg.nt8OverlaySleeves.length) {
    return cfg.nt8OverlaySleeves.map((s) => ({
      strategyName: String(s?.strategyName || s?.strategy || '').trim(),
      days: Array.isArray(s?.days)
        ? s.days.filter((d) => NT8_OVERLAY_DAY_KEYS.includes(d))
        : [...NT8_OVERLAY_DAY_KEYS],
      size: Number.isFinite(Number(s?.size)) && Number(s.size) >= 1 ? Number(s.size) : 1,
    }));
  }
  const legacy = String(cfg.nt8StrategyName || '').trim();
  if (legacy) {
    return [{ strategyName: legacy, days: [...NT8_OVERLAY_DAY_KEYS], size: 1 }];
  }
  return [makeEmptyNt8OverlaySleeve()];
}

export function validateNt8OverlaySleeves(sleeves) {
  const filled = (sleeves || []).filter(
    (s) => String(s.strategyName || '').trim() && Array.isArray(s.days) && s.days.length > 0,
  );
  if (!filled.length) {
    return 'Add at least one NT8 strategy with at least one active weekday.';
  }
  return null;
}

export function serializeNt8OverlaySleeves(sleeves) {
  return (sleeves || [])
    .filter((s) => String(s.strategyName || '').trim() && s.days?.length)
    .map((s) => {
      const raw = Number(s.size);
      const size = Number.isFinite(raw) && raw >= 1
        ? Math.min(Math.max(Math.round(raw), 1), 100)
        : 1;
      return {
        strategyName: String(s.strategyName).trim(),
        days: s.days.filter((d) => NT8_OVERLAY_DAY_KEYS.includes(d)),
        size,
      };
    });
}

/** NT8 webhook strategy names only, plus names already saved on this strategy. */
export function mergeNt8OverlayStrategyOptions(webhookNames, sleeves) {
  const set = new Set();
  (webhookNames || []).forEach((n) => { if (n) set.add(String(n).trim()); });
  (sleeves || []).forEach((s) => {
    const name = String(s?.strategyName || '').trim();
    if (name) set.add(name);
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b));
}
